
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1440 294"}},[_c('path',{attrs:{"fill":"#043e5c","d":"M1440 274.989c-137.369-17.522-388.186 15.754-651.877 18.71C499.31 296.937 190.636 273.012 0 270.682V0h1440v274.989z"}})])
      }
    
      }
    